import { useState, useEffect } from "react";
import useProductApi from "@apis/useProductApi";

/**
 * 管理 HC 商品資料的 Hook
 * 負責載入變更單的商品選項資料
 *
 * @returns {Array} 商品資料陣列
 */
const useHCProductData = () => {
	const { getCyclePurchaseProductsApi } = useProductApi();
	const [products, setProducts] = useState([]);

	useEffect(
		() => {
			const initProducts = async () => {
				const resp = await getCyclePurchaseProductsApi();
				if (resp) {
					setProducts(resp);
				}
			};
			initProducts();
		},
		// eslint-disable-next-line
		[getCyclePurchaseProductsApi],
	);

	return products;
};

export default useHCProductData;
